const common = {
  rowsPerPage: 'Rows per page',
    pickDateRange: 'Pick a date range',
    required: 'Required',
    backToDashboard: 'Back to dashboard',
    confirm: 'Confirm',
    remove: 'Remove',
    pickDate: 'Pick a date',
    clear: 'Clear',
    loading: 'Loading...',
    error: 'Error',
    save: 'Save',
    cancel: 'Cancel',
    add: 'Add',
    update: 'Update',
    delete: 'Delete',
    deleting: 'Deleting...',
    edit: 'Edit',
    view: 'View',
    download: 'Download',
    upload: 'Upload',
    share: 'Share',
    search: 'Search',
    filter: 'Filter',
    sort: 'Sort',
    actions: 'Actions',
    close: 'Close',
    closeDialog: 'Close dialog',
    breadcrumb: 'Breadcrumb',
    breadcrumbMore: 'More breadcrumb levels',
    pagination: 'Pagination',
    apply: 'Apply',
    clearAll: 'Clear All',
    retry: 'Retry',
    pageRenderFailed: 'Could not display this page',
    pageRenderFailedHint: 'A display error occurred. If retrying does not help, tell your administrator when it happened and which browser you used.',
    select: 'Select',
    selectAll: 'Select All',
    moreCount: '+{{count}} more',
    noData: 'No data available',
    noResults: 'No results found',
    all: 'All',
    more: 'More',
    less: 'Less',
    important: 'Important',
    language: 'Language',
    goHome: 'Go Home',
    refresh: 'Refresh',
    enabled: 'Enabled',
    disabled: 'Disabled',
    currentSession: 'Current Session',
    lastActivity: 'Last Activity',
    expires: 'Expires',
    registeredAt: 'Registered At',
    lastUsed: 'Last Used',
    noGroups: 'No groups',
    unknown: 'Unknown',
    dateUnknown: 'Date unknown',
    userInfoNotAvailable: 'User information not available. Please login again.',
    expand: 'Expand',
    collapse: 'Collapse',
  };

export default common;
